import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

type Props = {
  onCreateStudy: () => void;
  isLoading?: boolean; // ADD optional loading prop
};

function NoStudiesMessage({ onCreateStudy, isLoading = false }: Props) {
  const navigate = useNavigate();

  return (
    <div className="box-container flex flex-col items-center justify-center p-14 min-h-[400px]">
      <h2 className="text-2xl font-bold text-gray-700 mb-4">
        No Studies Available
      </h2>
      <p className="text-gray-600 mb-8 text-center">
        Create a study to view the dashboard and start managing your research.
      </p>
      <div className="flex gap-4">
        <Button
          variant="contained"
          onClick={onCreateStudy}
          disabled={isLoading} // Disable while loading
          sx={{
            "backgroundColor": "#5fbdd6",
            "color": "white",
            "borderRadius": "10px",
            "textTransform": "none",
            "padding": "10px 30px",
            "&:hover": {
              backgroundColor: "#4a9db0",
            },
            "&.Mui-disabled": {
              backgroundColor: "#f0f0f0",
              color: "#d0d0d0",
            },
          }}>
          {isLoading ? "Loading Patients..." : "Create Study"} {/* Show loading text */}
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/")}
          sx={{
            "color": "#727176",
            "border": "2px solid #727176",
            "borderRadius": "10px",
            "textTransform": "none",
            "padding": "10px 30px",
            "&:hover": {
              border: "2px solid #727176",
              backgroundColor: "rgba(114, 113, 118, 0.04)",
            },
          }}>
          Go to Home Diary
        </Button>
      </div>
    </div>
  );
};

export default NoStudiesMessage;